var map = {
	"./amanali-regalo.png": "a790",
	"./artboard-1-copia-2-100_upscayl_4x_realesrgan-x4plus.png": "1af6",
	"./barra.png": "7c12",
	"./bpc.png": "6388",
	"./btn-sortear-vacio.png": "ccc7",
	"./btn-sortear.png": "31c5",
	"./cibc.png": "295f",
	"./foursome-tepeji.png": "e42c",
	"./logo.png": "f826",
	"./pantalla.png": "8aaa",
	"./playstation.png": "ba7e",
	"./whisky.png": "ab05",
	"./xbox.png": "4ddc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e45";